import { createSelector, Selector } from '@reduxjs/toolkit'
import { activityMonitorStoreSelector } from './storeSelectors'
import { GlobalState } from 'store'
import { Activity } from 'store/activityMonitor'
import { RepositoryEntry } from 'store/repository'
import { NegotiationUpdate, ActivityDetail } from 'api'
import { createNegotiationDetailsSelector } from './negotiations'

export function createAllActivitiesSelector(): Selector<GlobalState, Activity[]> {
  return createSelector(activityMonitorStoreSelector, activitiesStore => {
    return activitiesStore.activities
  })
}

function createAllActivityNegotiationEntrySelector(): Selector<GlobalState, RepositoryEntry<NegotiationUpdate>[]> {
  return createSelector(createAllActivitiesSelector(), allActivities => {
    return allActivities.map(activity => ({
      entityId: activity.negotiationUpdate.entityId,
      lastUpdate: activity.negotiationUpdate,
      fieldUpdates: [],
      metaUpdates: []
    }))
  })
}

const createActivityGetterSelector: Selector<GlobalState, (id: string) => Activity | null> = createSelector(
  createAllActivitiesSelector(),
  allActivities => (id: string) => allActivities.find(activity => activity.id === id) || null
)

export function createAllActivityDetailsSelector(): Selector<GlobalState, ActivityDetail[]> {
  return createSelector(
    createNegotiationDetailsSelector(createAllActivityNegotiationEntrySelector()),
    createActivityGetterSelector,
    (negotiationDetails, getActivity) => {
      return negotiationDetails.map(negotiationDetail => {
        const activity = getActivity(negotiationDetail.negotiation.negotiationId)
        return { ...negotiationDetail, respondedStatus: activity && activity.respondedStatus ? activity.respondedStatus : null }
      })
    }
  )
}
